<template>
  <div class="container">

    <h1 v-if="$store.state.optional_data['winner_form'].form.title != undefined">
      {{$store.state.optional_data['winner_form'].form.title}}
    </h1>

    <div class="column-75 page-middle" v-if="$store.state.optional_data['entry'].form.sweepstakes != undefined">


      <h2 v-if="$store.state.optional_data['entry'].form.sweepstakes.success != undefined">
        {{$store.state.optional_data['entry'].form.sweepstakes.success}}
      </h2>

      <h4 v-if="$store.state.optional_data['entry'].form.sweepstakes.success_message != undefined">
        {{$store.state.optional_data['entry'].form.sweepstakes.success_message}}
      </h4>        
    </div>

    <h1 v-if="$store.state.optional_data['sweepstakes_selection'].post.sweepstakes != undefined">
        {{$store.state.optional_data['sweepstakes_selection'].post.sweepstakes.success_message}}
    </h1>

    <h1 v-if="$store.state.optional_data['instant_win_approval'].post.title != undefined " >
      {{$store.state.optional_data['instant_win_approval'].post.title}}
    </h1>

  </div>
</template>

<script>
    export default {
        name: "end_info",
    }
</script>

<style scoped>
</style>